import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Tooltip,
  Link,
  I18n,
} from 'components';
import {
  formatUnitString,
  formatDate,
} from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const PromisedPayment = ({ promisedPayment, promisedPaymentLink, currency }) => {
  const serviceAmount = formatUnitString(
    promisedPayment.totalDebt + promisedPayment.totalDebtFee,
    currency || 'CURRENCY',
  );

  const serviceDate = formatDate(promisedPayment.dueDate);
  const descriptionPath = promisedPayment.dueDate
    ? 'home.balance.promisedPaymentInfo'
    : 'home.balance.promisedPaymentInfoWithoutDate';

  return (
    <div className={cx('promisedPaymentContainer')}>
      <i className={cx('statusIndicator', 'warn')} />
      <Link href={promisedPaymentLink.url}>
        {promisedPaymentLink.title}
      </Link>
      {promisedPayment.list && (
        <Tooltip>
          {promisedPayment.list.map((payment, index) => (
            <I18n
              key={index}
              path="home.balance.promisedPaymentDescription"
              className={cx('tooltipMessage')}
              vars={{
                amount: formatUnitString(payment.amount, payment.currency),
                date: formatDate(payment.dueDate),
                fee: formatUnitString(payment.chargeAmount, payment.currency),
                name_prefix: payment.numberTP === 2 ? 'дополнительный ' : '',
              }}
            />
          ))}
        </Tooltip>
      )}
      <div className={cx('serviceDescription')}>
        {promisedPayment.totalDebt > 0 && (
          <I18n
            path={descriptionPath}
            vars={{
              amount: serviceAmount,
              date: serviceDate,
            }}
          />
        )}
      </div>
    </div>
  );
};

PromisedPayment.propTypes = {
  promisedPayment: PropTypes.shape({
    totalDebt: PropTypes.number.isRequired,
    totalDebtFee: PropTypes.number.isRequired,
    list: PropTypes.array,
    dueDate: PropTypes.string,
  }).isRequired,
  promisedPaymentLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  currency: PropTypes.string.isRequired,
};

export default PromisedPayment;
